import loadable from '@loadable/component';

export const Reviews = loadable(() => import('./index'), {
  resolveComponent: (components) => components.Reviews,
});
